import styled from "@emotion/styled";
import { Box, Grid, Paper, Typography } from "@mui/material";
import React from "react";
import AveargeTotals from "../../components/sales/AveargeTotals";
import SalesReportChart from "../../components/sales/charts/SalesReportChart";
import {
  salesReportPieChartData,
  salesReportPieChartOptions,
} from "../../../data/chartData";
import BarChart from "../../components/home/charts/BarChart";

const SalesAnalytics = () => {
  const ComponentWrapper = styled(Box)({
    marginTop: "10px",
    paddingBottom: "10px",
  });

  return (
    <Box sx={{ pt: "80px", pb: "20px" }}>
      <Typography variant="h6" sx={{ marginBottom: "14px" }}>
        Total Analytics
      </Typography>

      <ComponentWrapper>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <BarChart />
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper
              sx={{
                boxShadow: "none !important",
                borderRadius: "12px",
                borderStyle: "solid",
                borderWidth: "1px",
                borderColor: "divider",
                height: "100%",
                p: "10px",
              }}
            >
              <Typography variant="h6" sx={{ mb: 2 }}>
                Messages Report
              </Typography>
              <SalesReportChart
                chartOptions={salesReportPieChartOptions}
                chartData={salesReportPieChartData}
              />
            </Paper>
          </Grid>
        </Grid>
      </ComponentWrapper>
    </Box>
  );
};

export default SalesAnalytics;
